import { render, staticRenderFns } from "./ListColumnFilter.vue?vue&type=template&id=63cb8661&scoped=true"
import script from "./ListColumnFilter.vue?vue&type=script&lang=js"
export * from "./ListColumnFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cb8661",
  null
  
)

export default component.exports